import React from 'react';
import { useTeams } from '../hooks/team';
import { useTeamAppConfig } from '../hooks/teamApp';
import SingleTeamApp from '../components/Apps/SingleTeamApp';
import SingleTeamAppUI from '../components/Apps/SingleTeamAppUI';

export default function TeamApps() {
  const [teams] = useTeams();

  const [teamAppConfig] = useTeamAppConfig(window.currentLeague);
  const logo = (() => {
    if (window.currentLeague === 'Allsvenskan') {
      return (
        window.currentLogo ||
        '/wp-content/themes/sef-leagues/images/allsvenskan/allsvenskan-logo.svg'
      );
    }

    if (window.currentLeague === 'Superettan') {
      return (
        window.currentLogo ||
        'http://superettan.local/wp-content/themes/sef-leagues/images/superettan/SEF_Superettan_25_RGB.svg'
      );
    }

    return window.currentLogo || '';
  })();
  if (teams) {
    return (
      <>
        <div className="row">
          {teams?.map((team) => {
            return <SingleTeamApp team={team} />;
          })}
        </div>
        <div className="row justify-content-center">
          {logo ? (
            <SingleTeamAppUI
              title={window.currentLeague}
              logo={logo}
              logoAlt={window.currentLeague}
              teamAppConfig={teamAppConfig}
            />
          ) : null}
        </div>
      </>
    );
  }
}
